var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [_c('div', {
    ref: "imageHolder",
    staticClass: "image-holder",
    attrs: {
      "id": "image-holder"
    }
  }), _vm.currentStep.id ? _c('div', {
    staticClass: "step"
  }, [_vm.isCompleteWordStep ? _c('div', {
    staticClass: "td-holder",
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "big-wrap bigText",
    attrs: {
      "id": ("section-" + (_vm.currentStep.id))
    }
  }, [_c('color-block-text', {
    attrs: {
      "is-simple": true,
      "text": _vm.currentRound.completeWord,
      "answer": _vm.currentStep.answer,
      "text-step": 5
    }
  })], 1)]) : _vm._e(), !_vm.isCompleteWordStep ? _c('div', {
    staticClass: "td-holder",
    attrs: {
      "transition": "fade"
    }
  }, _vm._l(_vm.getWordPartSteps, function (step, index) {
    return _c('div', {
      key: step.id,
      staticClass: "normal-wrap normalText",
      attrs: {
        "id": ("section-" + (step.id))
      }
    }, [_c('color-block-text', {
      attrs: {
        "is-simple": true,
        "text": step.answer,
        "text-step": index
      }
    })], 1);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "curtain"
  })]) : _vm._e(), _vm._t("keyboard")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }